import { render } from "./achievement.vue?vue&type=template&id=e88e3936&scoped=true"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"

import "./achievement.vue?vue&type=style&index=0&id=e88e3936&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88e3936"]])

export default __exports__